import axios from "../axios";

const getDepartmentsByStateId = (id) => {
    return axios
        .get(`/admin/department/list/${id}`)
        .then((response) => response.data);
};

const getActiveDepartmentsByStateId = (id) => {
    return axios
        .get(`/division/department/${id}`)
        .then((response) => response.data.data);
};

export default {
    getDepartmentsByStateId,
    getActiveDepartmentsByStateId
};
